import {
  Security as SecurityIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  CheckCircle as CheckIcon,
} from '@mui/icons-material';

/**
 * Get reference type color
 * @param {string} referenceType - Reference type
 * @returns {string} MUI color name
 */
export const getReferenceTypeColor = referenceType => {
  switch (referenceType) {
    case 'template_validation':
      return 'primary';
    case 'execution_input':
      return 'secondary';
    case 'execution_anonymization':
      return 'success';
    case 'api_call':
      return 'info';
    default:
      return 'default';
  }
};

/**
 * Get severity color
 * @param {string} severity - Severity level
 * @returns {string} MUI color name
 */
export const getSeverityColor = severity => {
  switch (severity) {
    case 'critical':
      return 'error';
    case 'warning':
      return 'warning';
    case 'info':
      return 'info';
    default:
      return 'default';
  }
};

/**
 * Get severity icon
 * @param {string} severity - Severity level
 * @returns {React.ReactNode} Icon component
 */
export const getSeverityIcon = severity => {
  switch (severity) {
    case 'critical':
      return <ErrorIcon />;
    case 'warning':
      return <WarningIcon />;
    case 'info':
      return <CheckIcon />;
    default:
      return <SecurityIcon />;
  }
};

/**
 * Format timestamp
 * @param {string|Date} timestamp - Timestamp to format
 * @returns {string} Formatted timestamp string
 */
export const formatTimestamp = timestamp => {
  return new Date(timestamp).toLocaleString();
};
